export default "__VITE_ASSET__DTl0TiyL__"